import React, { useEffect, useState } from "react";
import moment from "moment";
import "moment/locale/fr";

export default function Profile() {
  return <h1>soon</h1>;
}
